import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-auth",
  "use": "icon-auth-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-auth\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z m55.296 832L194.56 311.296l174.592-0.512 198.656 313.856 141.824-313.856 112.64 0.512-254.976 520.704z\" p-id=\"24910\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol